import { PagedResponse } from "@/types/PagedResponse";
import { PageRequest } from "@/types/pagination";
import { Segurado } from "@/types/Segurado";
import { Sort } from "@/types/sort";
import { buildFilter } from "@/utils/filter.util";
import axios, { AxiosPromise } from "axios"; 

export const findClientes = (searchParams?: string, pagination?: PageRequest, sort?: Sort): AxiosPromise<PagedResponse<Segurado>> => 
    axios.get(`/api/segurado`, {
        params: {
            search: searchParams,
            ...sort,
            ...pagination
        }
    });

export const autoCompleteAtivo = (search: string): AxiosPromise<PagedResponse<any>> =>
    findClientes(search ? buildFilter(['nome'])(search) : '',{page: 0, size: 20},{sort: 'nome'});

export const getByCodigo = (codigo: string): AxiosPromise<Segurado> => 
    axios.get(`/api/segurado/${codigo}`);    

export const create = (cliente: Segurado): AxiosPromise<Segurado> => 
    axios.post(`/api/segurado`, cliente); 

export const update = (cliente: Segurado, id: string): AxiosPromise<Segurado> => 
    axios.put(`/api/segurado/${id}`, cliente); 

export const remove = (codigo: string): AxiosPromise<void> => 
    axios.delete(`/api/segurado/${codigo}`);     